import apiClient from '../client/api-client'
const shares = 'shares'
const grantors = 'grantors'
const v2 = '-v2'

export default {
  /*
     Load patient shared profile
     */
  async getSharedProfiles({ ...params }) {
    try {
      const { data } = await apiClient.get(`${shares}/${grantors}`, { params })
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
     Reject/Pending shared profiles
     */
  async updateSharedProfile(sharingID, payload) {
    try {
      const { data } = await apiClient.put(`${shares}${v2}/${sharingID}`, payload)
      return data
    } catch (err) {
      throw new Error(err)
    }
  }
}
